/**
 * Nature & plants emoji category with searchable keywords
 */
export const nature = {
  name: 'Nature',
  icon: '🌸',
  emojis: [
    { emoji: '💐', keywords: ['bouquet', 'flowers', 'gift', 'arrangement', 'pretty'] },
    { emoji: '🌸', keywords: ['cherry', 'blossom', 'flower', 'spring', 'pink', 'japan'] },
    { emoji: '💮', keywords: ['flower', 'white', 'japanese', 'symbol', 'pretty'] },
    { emoji: '🏵️', keywords: ['rosette', 'flower', 'decoration', 'award', 'medal'] },
    { emoji: '🌹', keywords: ['rose', 'flower', 'love', 'romance', 'red', 'valentine'] },
    { emoji: '🥀', keywords: ['wilted', 'flower', 'dead', 'sad', 'dying'] },
    { emoji: '🌺', keywords: ['hibiscus', 'flower', 'tropical', 'hawaii', 'pink'] },
    { emoji: '🌻', keywords: ['sunflower', 'flower', 'yellow', 'sun', 'summer'] },
    { emoji: '🌼', keywords: ['blossom', 'flower', 'yellow', 'daisy', 'spring'] },
    { emoji: '🌷', keywords: ['tulip', 'flower', 'spring', 'pink', 'netherlands'] },
    { emoji: '🌱', keywords: ['seedling', 'plant', 'grow', 'sprout', 'new'] },
    { emoji: '🪴', keywords: ['potted', 'plant', 'houseplant', 'indoor', 'green'] },
    { emoji: '🌲', keywords: ['evergreen', 'tree', 'christmas', 'pine', 'forest'] },
    { emoji: '🌳', keywords: ['tree', 'deciduous', 'forest', 'nature', 'green'] },
    { emoji: '🌴', keywords: ['palm', 'tree', 'tropical', 'beach', 'vacation'] },
    { emoji: '🌵', keywords: ['cactus', 'desert', 'plant', 'prickly', 'succulent'] },
    { emoji: '🌾', keywords: ['rice', 'grain', 'wheat', 'harvest', 'farm'] },
    { emoji: '🌿', keywords: ['herb', 'leaf', 'plant', 'green', 'nature'] },
    { emoji: '☘️', keywords: ['shamrock', 'clover', 'irish', 'luck', 'green'] },
    { emoji: '🍀', keywords: ['clover', 'four', 'leaf', 'luck', 'irish'] },
    { emoji: '🍁', keywords: ['maple', 'leaf', 'fall', 'autumn', 'canada'] },
    { emoji: '🍂', keywords: ['fallen', 'leaf', 'autumn', 'fall', 'brown'] },
    { emoji: '🍃', keywords: ['leaf', 'wind', 'blow', 'flutter', 'green'] },
    { emoji: '🍄', keywords: ['mushroom', 'fungus', 'toadstool', 'mario', 'forest'] },
    { emoji: '🌰', keywords: ['chestnut', 'nut', 'autumn', 'fall', 'acorn'] },
    { emoji: '🦀', keywords: ['crab', 'ocean', 'beach', 'seafood', 'zodiac'] },
    { emoji: '🦞', keywords: ['lobster', 'seafood', 'ocean', 'claw', 'red'] },
    { emoji: '🦐', keywords: ['shrimp', 'prawn', 'seafood', 'ocean', 'small'] },
    { emoji: '🦑', keywords: ['squid', 'ocean', 'tentacles', 'calamari', 'sea'] },
    { emoji: '🌍', keywords: ['earth', 'globe', 'europe', 'africa', 'world', 'planet'] },
    { emoji: '🌎', keywords: ['earth', 'globe', 'americas', 'world', 'planet'] },
    { emoji: '🌏', keywords: ['earth', 'globe', 'asia', 'australia', 'world', 'planet'] },
    { emoji: '🌐', keywords: ['globe', 'meridians', 'world', 'international', 'web'] },
    { emoji: '🪨', keywords: ['rock', 'stone', 'boulder', 'nature', 'solid'] },
    { emoji: '🌑', keywords: ['moon', 'new', 'dark', 'night', 'phase'] },
    { emoji: '🌒', keywords: ['moon', 'waxing', 'crescent', 'night', 'phase'] },
    { emoji: '🌓', keywords: ['moon', 'first', 'quarter', 'night', 'phase'] },
    { emoji: '🌔', keywords: ['moon', 'waxing', 'gibbous', 'night', 'phase'] },
    { emoji: '🌕', keywords: ['moon', 'full', 'night', 'bright', 'phase'] },
    { emoji: '🌖', keywords: ['moon', 'waning', 'gibbous', 'night', 'phase'] },
    { emoji: '🌗', keywords: ['moon', 'last', 'quarter', 'night', 'phase'] },
    { emoji: '🌘', keywords: ['moon', 'waning', 'crescent', 'night', 'phase'] },
    { emoji: '🌙', keywords: ['moon', 'crescent', 'night', 'sleep', 'dream'] },
    { emoji: '🌚', keywords: ['moon', 'new', 'face', 'dark', 'creepy'] },
    { emoji: '🌛', keywords: ['moon', 'first', 'quarter', 'face', 'night'] },
    { emoji: '🌜', keywords: ['moon', 'last', 'quarter', 'face', 'night'] },
    { emoji: '☀️', keywords: ['sun', 'sunny', 'bright', 'hot', 'summer', 'weather'] },
    { emoji: '🌝', keywords: ['moon', 'full', 'face', 'night', 'bright'] },
    { emoji: '🌞', keywords: ['sun', 'face', 'bright', 'happy', 'summer'] },
    { emoji: '⭐', keywords: ['star', 'night', 'sky', 'favorite', 'rating'] },
    { emoji: '🌟', keywords: ['star', 'glowing', 'sparkle', 'shine', 'bright'] },
    { emoji: '🌠', keywords: ['shooting', 'star', 'wish', 'night', 'meteor'] },
    { emoji: '☁️', keywords: ['cloud', 'weather', 'sky', 'overcast', 'fluffy'] },
    { emoji: '⛅', keywords: ['cloud', 'sun', 'partly', 'cloudy', 'weather'] },
    { emoji: '⛈️', keywords: ['storm', 'thunder', 'lightning', 'rain', 'weather'] },
    { emoji: '🌤️', keywords: ['sun', 'cloud', 'small', 'weather', 'partly'] },
    { emoji: '🌥️', keywords: ['sun', 'cloud', 'large', 'weather', 'mostly'] },
    { emoji: '🌦️', keywords: ['sun', 'rain', 'cloud', 'weather', 'shower'] },
    { emoji: '🌧️', keywords: ['rain', 'cloud', 'weather', 'rainy', 'wet'] },
    { emoji: '🌨️', keywords: ['snow', 'cloud', 'weather', 'winter', 'cold'] },
    { emoji: '🌩️', keywords: ['lightning', 'cloud', 'thunder', 'storm', 'weather'] },
    { emoji: '🌪️', keywords: ['tornado', 'wind', 'storm', 'twister', 'weather'] },
    { emoji: '🌫️', keywords: ['fog', 'mist', 'weather', 'haze', 'visibility'] },
    { emoji: '🌬️', keywords: ['wind', 'blow', 'face', 'breeze', 'weather'] },
    { emoji: '🌈', keywords: ['rainbow', 'colors', 'sky', 'pride', 'weather'] },
    { emoji: '☂️', keywords: ['umbrella', 'rain', 'weather', 'protection', 'wet'] },
    { emoji: '☔', keywords: ['rain', 'umbrella', 'weather', 'wet', 'drops'] },
    { emoji: '⚡', keywords: ['lightning', 'bolt', 'thunder', 'electric', 'power', 'flash'] },
    { emoji: '❄️', keywords: ['snowflake', 'cold', 'winter', 'frozen', 'ice'] },
    { emoji: '☃️', keywords: ['snowman', 'winter', 'cold', 'snow', 'christmas'] },
    { emoji: '⛄', keywords: ['snowman', 'winter', 'cold', 'snow', 'frosty'] },
    { emoji: '🔥', keywords: ['fire', 'hot', 'flame', 'lit', 'burn', 'heat'] },
    { emoji: '💧', keywords: ['water', 'drop', 'droplet', 'sweat', 'tear'] },
    { emoji: '🌊', keywords: ['wave', 'ocean', 'sea', 'water', 'surf', 'beach'] },
  ],
};

export default nature;

